var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgAvatarOrg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E0E0E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9881 11C20.5071 11 21.026 11.0182 21.5439 11.0547C24.6432 11.2734 26.5199 11.8552 27.3908 12.198C27.7443 12.337 27.9761 12.6767 27.9761 13.0552V21.803C27.9761 26.2644 21.8371 28.9191 20.3226 29.5061C20.1073 29.5898 19.8688 29.5898 19.6535 29.5061C18.1388 28.9191 12 26.2644 12 21.803V13.0552C12 12.6767 12.2316 12.337 12.585 12.198C13.456 11.8552 15.3327 11.2734 18.432 11.0547C18.9501 11.0182 19.4688 11 19.9881 11ZM22.078 21.2218H18.9993V15.6567C18.9993 15.4841 18.8585 15.3439 18.6845 15.3439H17.5511C17.3775 15.3439 17.2364 15.4841 17.2364 15.6567V22.6631V22.6636C17.2364 22.7476 17.2701 22.8238 17.3245 22.88C17.326 22.8814 17.3271 22.8832 17.3289 22.8846C17.3303 22.886 17.3321 22.8875 17.3332 22.8889C17.39 22.9428 17.4662 22.9764 17.5508 22.9764H17.5511H22.078C22.2513 22.9764 22.3921 22.8359 22.3921 22.6631V21.5351C22.3921 21.3619 22.2513 21.2218 22.078 21.2218Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 18.8235,
    fill: "white",
    transform: "translate(12 11)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgAvatarOrg);
export default __webpack_public_path__ + "static/media/img_avatar_org.a371ea2a1921894fc52a0a8a1a010d06.svg";
export { ForwardRef as ReactComponent };